import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

/**
 * 呼叫協助登入
 * @param {*} i18n
 * @param {*} store
 */
export function callHelpLogin(i18n) {
  const driverObj = driver({
    showProgress: true,
    prevBtnText: i18n.$t('DriverTourHelp').previous,
    nextBtnText: i18n.$t('DriverTourHelp').next,
    doneBtnText: i18n.$t('DriverTourHelp').done,
    steps: [
      {
        element: '#v-step-0',
        popover: {
          title: i18n.$t('Label').account,
          description: i18n.$t('LoginPage').InputAccount,
        },
      },
      {
        element: '#v-step-1',
        popover: {
          title: i18n.$t('Label').password,
          description: i18n.$t('LoginPage').InputPassword,
        },
      },
      {
        element: '#v-step-2',
        popover: {
          title: i18n.$t('LoginPage').LoginMethod,
          description: i18n.$t('LoginPage').SelectServer,
        },
      },
      {
        element: '#v-step-3',
        popover: {
          title: i18n.$t('Menu').login_text,
          description: i18n.$t('LoginPage').FinishedInputLogin,
        },
      },
    ],
  });
  driverObj.drive();
}

/**
 * 呼叫協助：若當前並無任何人擁有使用者帳號
 * @param {*} i18n
 */
export function callHelpNoAccount(i18n) {
  const driverObj = driver({
    popoverClass: 'classSPCLoginError',
  });

  driverObj.highlight({
    popover: {
      description: i18n.$t('LoginPage').NoAccount,
    },
  });
}

/**
 * 呼叫協助：SPC登入錯誤訊息重點說明
 */
export function callHelpSPCLoginError(i18n) {
  const driverObj = driver({
    popoverClass: 'classSPCLoginError',
  });
  const htmlContext = `
  <p style="color:red">Login failed: Incorrect password.</p>
  <p>${i18n.$t('LoginPage').IncorrectPassword}</p>
  <br>
  <p style="color:red">User does not exist</p>
  <p>${i18n.$t('LoginPage').NoUserExist}</p>
  <br>
  <p style="color:red">Menu get failed</p>
  <p>${i18n.$t('LoginPage').UserIsForbid}</p>
  `;
  driverObj.highlight({
    popover: {
      description: htmlContext,
    },
  });
}
